<template>
  <form @submit.prevent="onSubmit">
    <div class="order-operation-notes-vetting-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Vet Comment</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Original">
          <b-input
            name="content_original"
            type="textarea"
            :disabled="true"
            :value="target.content"
          >
          </b-input>
        </b-field>
        <b-checkbox v-model="target.isSensitive" :disabled="true">Confidential</b-checkbox>
        <hr>
        <b-field label="Revised">
          <b-input
            name="content"
            type="textarea"
            :disabled="loading"
            v-model="form.content"
          ></b-input>
        </b-field>
        <b-checkbox v-model="form.is_sensitive" :disabled="loading">Confidential</b-checkbox>
      </section>
      <footer class="modal-card-foot has-text-right">
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
        <button class="button is-info" :class="{ 'is-loading' : loading }">Submit</button>
      </footer>
    </div>
  </form>
</template>

<script>

import { OrderService } from "@/services/order.service";

export default {
  props: {
    target: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    form: {
      content: "",
      is_sensitive: false
    },
    loading: false
  }),
  mounted() {
    // Copy data from comment being vetted as a starting point.
    this.form.content = this.target.content;
    this.form.is_sensitive = this.target.isSensitive ? true : false;
  },
  methods: {
    onSubmit() {

      this.loading = true;
      const payload = Object.assign({}, this.form);

      OrderService.vetComment(this.target.commentableId, this.target.id, payload)
      .then(() => {
        // Success
        this.$buefy.toast.open({
          message: "Comment has been vetted.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit('comment-saved');
        this.$parent.close();
      })
      .catch(() => {
        // Validation should have been handled by interceptor
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Comment/VettingCommentModal.vue